import React, { Component, PropTypes } from 'react';
import styles from '../../../styles/AuthPopup.scss';
import vkIcon from '../../../imgs/vk-icon.svg';
import fbIcon from '../../../imgs/fb-icon.svg';
import okIcon from '../../../imgs/ok-icon.svg';
import twitterIcon from '../../../imgs/twitter-icon.svg';
import gplusIcon from '../../../imgs/gplus-icon.svg';
import InlineSVG from 'react-svg-inline';



export default class RegistrationPopupSocBtns extends Component {
  render() {
    return (
      <div className={styles.socBtnsContainer}>
        <InlineSVG
          className={styles.socBtn}
          svg={gplusIcon} />
        <InlineSVG
          className={styles.socBtn}
          svg={twitterIcon} />
        <InlineSVG
          className={styles.socBtn}
          svg={vkIcon} />
        <InlineSVG
          className={styles.socBtn}
          svg={fbIcon} />
        <InlineSVG
          className={styles.socBtn}
          svg={okIcon} />
      </div>
    );
  }
}



RegistrationPopupSocBtns.propTypes = {
};



/** WEBPACK FOOTER **
 ** ./src/components/SignInPopup/elements/SignInPopupSocBtns.jsx
 **/